import React, { useEffect, useRef, useState } from "react";

import OtpInput from "react-otp-input";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";

import useTimer from "../hooks/useTimer";
import { Loader } from "../common/loader";
import { resendOTPSeconds, ROLES } from "../helpers/constants";
import ContcatAdminSupport from "../common/ContcatAdminSupport";
import VerifyPhone from "./SignupTaiwindComponents/VerifyPhone";
import VerifyEmail from "./SignupTaiwindComponents/VerifyEmail";
import { userSigupAction } from "../../redux/slices/user/userSignUpSlice";
import HubspotCookieBreakerInput from "../common/HubspotCookieBreakerInput";
import {
  autoFocusOnField,
  censorEmail,
  decryptPayload,
  getObjLength,
  getSignupUserId,
  persistSignupUserId,
} from "../helpers/utils";
import {
  isEldoradoFromWhere,
  isEldoradoSiteSignup,
  withEldoradoFromWhere,
} from "../helpers/eldoradoSignup";
import { isAffiliateUser } from "../helpers/affiliateSignup";

export const OTPFieldStyle = {
  background: "#F6F9FC",
  border: "1px solid rgba(52, 75, 91, 0.1)",
  borderRadius: "3px",
  width: "40px",
  height: "55px",
  fontWeight: "600",
  fontSize: "20px",
  lineHeight: "55px",
  textAlign: "center",
  color: "#0D120B",
};

const PersonalTokenScreen = (props) => {
  const navigate = useNavigate();
  const [otp, SetOTP] = useState("");
  const [otpErr, SetOTPErr] = useState(undefined);
  const [otpSucess, SetOTPSucess] = useState("");
  const [emailScreen, SetEmailScreen] = useState(false);
  const [open, setOpen] = useState(false);
  const [diableMobileBtn, setdiableMobileBtn] = useState(false);
  const [diableEmailBtn, setdiableEmailBtn] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [emailOTP, setEmailOTP] = useState("");
  const [emailOTPErr, setEmailOTPErr] = useState(undefined);
  const [emailOTPSucess, setEmailOTPSucess] = useState("");
  const [emailSpamMsg, setEmailSpamMsg] = useState(
    " If you haven't received the email in your inbox, please check your email spam folder.",
  );
  const [validate, setValidate] = useState(false);
  const hasAutoAdvanced = useRef(false);
  const emailOtpSubmitting = useRef(false);
  const phoneOtpSubmitting = useRef(false);

  //initializes the timer states for hook
  const {
    timer,
    isTimerActive,
    startTimer,
    stopTimer,
    formatTimeForResendOTP,
  } = useTimer(120);

  const dispatch = useDispatch();
  const accCreated = useSelector((state) => state.signUpUser.createAccResponse);
  const otpResponse = useSelector(
    (state) => state.signUpUser.otpVerificationResponse,
  );
  const resendOtpResponse = useSelector((state) => state.signUpUser.newOTP);
  const mobileVerified1 = useSelector((state) => state.signUpUser?.step1Mobile);
  const [mobileVerified, setMobileVerified] = useState(mobileVerified1);
  const emailOTPResponse = useSelector(
    (state) => state.signUpUser.emailOTPVerificationResponse,
  );
  const resendEmailOtpResponse = useSelector(
    (state) => state.signUpUser.newEmailOTP,
  );
  const emailVerified = useSelector((state) => state.signUpUser.step1Email);
  const resendPhone_OTP = useSelector(
    (state) => state.signUpUser.resendPhone_OTP,
  );
  const resendEmail_OTP = useSelector(
    (state) => state.signUpUser.resendEmail_OTP,
  );
  const signupDetails = useSelector(
    (state) => state.signUpUser.userSignupDetails,
  );
  const { isBypassOptionAvailable } = useSelector((state) => state?.properties);
  const { investorsID } = useSelector((state) => state?.signUpUser);
  const userDataFromSession = localStorage.getItem("userSignupDetails")
    ? JSON.parse(localStorage.getItem("userSignupDetails"))
    : "";
  const property_search_data = JSON.parse(
    localStorage.getItem("property_search_data"),
  );
  const risk_report_id = property_search_data?.risk_report_id;
  console.log(risk_report_id, "<=== risk_report_id ==>QQQ");
  const role = decryptPayload(localStorage.getItem("roles"));
  const isMobileVerified = JSON.parse(localStorage.getItem("emailScreen"));
  const userIdFromSession = getSignupUserId();
  const investor_id =
    investorsID ||
    JSON.parse(localStorage.getItem("investor_id")) ||
    JSON.parse(localStorage.getItem("county_user_id")); // for make (normal or county) investor to our customer with selected properties
  console.log(investorsID, "signup details==m>>", signupDetails);
  console.log(
    userIdFromSession,
    "<<=== session values userSignupDetails==>>",
    userDataFromSession,
  );
  const category = decryptPayload(localStorage.getItem("category"));
  const isPlainSignup = JSON.parse(localStorage.getItem("plain_signup"));
  useEffect(() => {
    if (isMobileVerified === 1) {
      SetEmailScreen(true);
      setMobileVerified(true);
      stopTimer();
    }
    const img = document.getElementById("trackingPixel");
    if (img) {
      img.remove(); // Remove the tracking pixel on page change
    }
    localStorage.removeItem("referral_code");
    localStorage.removeItem("valueOf");
  }, []);

  useEffect(() => {
    console.log(props?.missingEmail, "props==>", props?.missingPhone);

    if (props?.missingPhone) {
      SetEmailScreen(true);
      setMobileVerified(true);
    }

    if (props?.missingEmail) {
      SetEmailScreen(false);
      setMobileVerified(true);
    }
  }, [props?.missingPhone, props?.missingEmail]);

  useEffect(() => {
    if (mobileVerified1) {
      // props.onBtnClick();
      handleClose();
    }

    if (Object.keys(resendOtpResponse).length > 0) {
      if (resendOtpResponse?.success) {
        handleClose();
      } else {
        validated();
      }
    }
  }, [mobileVerified1, resendOtpResponse]);

  useEffect(() => {
    if (emailVerified) {
      // props.onBtnClick();
      handleCloseEmailLoader();
    }

    if (Object.keys(resendEmailOtpResponse).length > 0) {
      if (resendEmailOtpResponse?.success) {
        handleCloseEmailLoader();
      } else {
        validatedEmail();
      }
    }
  }, [emailVerified, resendEmailOtpResponse]);

  useEffect(() => {
    if (Object.keys(otpResponse).length > 0 && !otpResponse.success) {
      validated();
    }
  }, [otpResponse]);

  useEffect(() => {
    if (Object.keys(emailOTPResponse).length > 0 && !emailOTPResponse.success) {
      validatedEmail();
    }
  }, [emailOTPResponse]);

  useEffect(() => {
    if (
      !props?.isTailwindComponent &&
      mobileVerified &&
      emailVerified &&
      !hasAutoAdvanced.current
    ) {
      hasAutoAdvanced.current = true;
      goNext();
    }
  }, [mobileVerified, emailVerified, props?.isTailwindComponent]);

  const validated = () => {
    phoneOtpSubmitting.current = false;
    if (!otpResponse.success || !resendOtpResponse?.success) {
      SetOTPErr(otpResponse?.data?.message || resendOtpResponse?.data?.message);
      SetOTPSucess("");
      handleClose();
      SetOTP("");
    } else {
      SetOTPErr("");
      handleClose();
    }
    setOpen(false);
  };
  const validatedEmail = () => {
    emailOtpSubmitting.current = false;
    if (!emailOTPResponse.success || !resendEmailOtpResponse?.success) {
      setEmailOTPErr(
        emailOTPResponse?.data?.message ||
          resendEmailOtpResponse?.data?.message,
      );
      setEmailOTPSucess("");
      handleCloseEmailLoader();
      setEmailOTP("");
    } else {
      setEmailOTPErr("");
      handleCloseEmailLoader();
    }
    setOpenEmail(false);
  };
  const handleChange = (otp) => {
    SetOTPSucess("");
    if (otp.length === 6) {
      SetOTPErr("");
    }
    console.log("otp handled==>>", otp);
    SetOTP(otp);
    setValidate(false);
    if (
      otp.length === 6 &&
      !open &&
      !diableMobileBtn &&
      !phoneOtpSubmitting.current
    ) {
      otpValidate({ preventDefault: () => {} }, otp);
    }
  };

  const handleChangeEmailOTP = (otp) => {
    setEmailOTPSucess("");
    if (otp.length === 6) {
      setEmailOTPErr("");
      setEmailSpamMsg("");
    }
    console.log("otp email handled==>>", otp);
    setEmailOTP(otp);
    setValidate(false);
    if (
      otp.length === 6 &&
      !openEmail &&
      !diableEmailBtn &&
      !emailOtpSubmitting.current
    ) {
      emailOTPValidate({ preventDefault: () => {} }, otp);
    }
  };

  const handleClose = () => {
    phoneOtpSubmitting.current = false;
    console.log("otp number==>", resendOtpResponse);

    if (otpResponse?.success) {
      SetOTPSucess(otpResponse?.message);
      if (props?.isAdmin && !investor_id) {
        resendEmailOTP();
      }
      if (investor_id) {
        goNext();
      } else {
        SetEmailScreen(true);
      }
      stopTimer();
      setMobileVerified(true);
      setdiableMobileBtn(true);
      if (props?.missingEmail) {
        dispatch(userSigupAction.skipEmailOTP(true));
      }
    }

    if (resendOtpResponse?.success) {
      SetOTPSucess(resendOtpResponse?.message);
      setdiableMobileBtn(false);
      SetOTPErr("");
    }

    setOpen(false);
  };
  const handleCloseEmailLoader = () => {
    emailOtpSubmitting.current = false;
    console.log("otp email==>", resendEmailOtpResponse);
    if (emailOTPResponse?.success) {
      setEmailOTPSucess(emailOTPResponse?.message);
      setdiableEmailBtn(true);
    }
    if (resendEmailOtpResponse?.success) {
      setEmailOTPSucess(
        resendEmailOtpResponse?.message +
          " If you haven't received the email in your inbox, please check your email spam folder.",
      );
      setEmailOTPErr("");
      setdiableEmailBtn(false);
    }
    setOpenEmail(false);
  };
  const handleToggle = () => {
    setOpen(true);
  };

  const otpValidate = (event, codeOverride) => {
    event?.preventDefault?.();
    let payload = {};
    const code = codeOverride ?? otp;
    if (phoneOtpSubmitting.current) {
      return;
    }
    SetOTPSucess("");
    // SetEmailScreen(true);
    // props.onBtnClick();
    if (code.length === 6) {
      phoneOtpSubmitting.current = true;
      const resolvedUserId =
        (getObjLength(accCreated)
          ? accCreated.data?.user_id
          : userIdFromSession) || props?.user_id;
      persistSignupUserId(resolvedUserId);
      let inputParam = withEldoradoFromWhere(
        {
          user_id: resolvedUserId,
          verification_code: code,
          step: investor_id ? 2 : 0,
          step_key: investor_id ? "VERIFY_ANSWERS" : "VERIFY_PHONE_OTP",
        },
        props?.selectedRowData,
      );
      autoFocusOnField();
      dispatch(userSigupAction.clearResedOTP());
      if (isBypassOptionAvailable) {
        payload = {
          url: "admin/verify-otp/phone",
          data: inputParam,
          token: true,
        };
      } else {
        payload = { url: "verify-otp/phone", data: inputParam };
      }
      dispatch(userSigupAction.userVerifyOTP(payload));
      handleToggle();
    } else {
      SetOTPErr("Please Enter Valid Token");
    }
  };

  const emailOTPValidate = (event, codeOverride) => {
    event?.preventDefault?.();
    let payload = {};
    const code = codeOverride ?? emailOTP;
    if (emailOtpSubmitting.current) {
      return;
    }
    setEmailOTPSucess("");
    // props.onBtnClick();
    if (code.length === 6) {
      emailOtpSubmitting.current = true;
      setEmailSpamMsg("");
      const resolvedUserId =
        (getObjLength(accCreated)
          ? accCreated.data?.user_id
          : userIdFromSession) || props?.user_id;
      persistSignupUserId(resolvedUserId);
      let inputParam = withEldoradoFromWhere(
        {
          user_id: resolvedUserId,
          verification_code: code,
          step: investor_id ? 2 : 1,
          step_key: investor_id ? "VERIFY_ANSWERS" : "VERIFY_EMAIL_OTP",
        },
        props?.selectedRowData,
      );
      autoFocusOnField();
      dispatch(userSigupAction.clearResedOTP());
      if (isBypassOptionAvailable) {
        payload = {
          url: "admin/verify-otp/email",
          data: inputParam,
          token: true,
        };
      } else {
        payload = { url: "verify-otp/email", data: inputParam };
      }
      dispatch(userSigupAction.userVerifyEmailOTP(payload));
      setOpenEmail(!openEmail);
      // handleToggle();
    } else {
      setEmailOTPErr("Please Enter Valid Token");
    }
  };

  const resendOTP = () => {
    let payload = {};
    let inputParam = withEldoradoFromWhere(
      {
        user_id:
          (getObjLength(accCreated)
            ? accCreated.data?.user_id
            : userIdFromSession) || props?.user_id,
      },
      props?.selectedRowData,
    );
    if (isBypassOptionAvailable) {
      payload = {
        url: "admin/resend-otp/phone",
        data: inputParam,
        token: true,
      };
    } else {
      payload = { url: "resend-otp/phone", data: inputParam };
    }
    dispatch(userSigupAction.resedOTP(payload));
    handleToggle();
    SetOTP("");
    autoFocusOnField();
  };

  const resendEmailOTP = () => {
    let payload = {};
    setEmailSpamMsg("");
    let inputParam = withEldoradoFromWhere(
      {
        user_id:
          (getObjLength(accCreated)
            ? accCreated.data?.user_id
            : userIdFromSession) || props?.user_id,
      },
      props?.selectedRowData,
    );
    if (isBypassOptionAvailable) {
      payload = {
        url: "admin/resend-otp/email",
        data: inputParam,
        token: true,
      };
    } else {
      payload = { url: "resend-otp/email", data: inputParam };
    }
    dispatch(userSigupAction.resedEmailOTP(payload));
    setOpenEmail(!openEmail);
    setEmailOTP("");
    autoFocusOnField();
  };

  const resendOTPButtonClick = (type) => {
    if (type === "email") {
      resendEmailOTP();
    } else {
      resendOTP();
    }
    startTimer(resendOTPSeconds);
  };

  const goNext = () => {
    console.log("go next step==>", category);
    // if (category !== "complete_protection" && !isPlainSignup) {
    //   // props.onBtnClick(null, "owner_verification"); // to avoid the owner verification step for basic and enhanced monitoring
    //   props.onBtnClick(null);
    // } else {
    //   props.onBtnClick(null, investor_id ? "owner_verification" : undefined);
    // }
    props.onBtnClick(
      null,
      investor_id ||
        isEldoradoSiteSignup() ||
        isEldoradoFromWhere(props?.selectedRowData) ||
        isAffiliateUser(props?.selectedRowData)
        ? "owner_verification"
        : undefined,
    );
    stopTimer();
  };

  useEffect(() => {
    if (resendPhone_OTP) {
      resendOTP();
      if (!investor_id) {
        resendEmailOTP();
      }
    }
  }, [resendPhone_OTP]);
  useEffect(() => {
    if (resendEmail_OTP && !investor_id) {
      resendEmailOTP();
    }
  }, [resendEmail_OTP]);

  console.log(open, "<== loader false==>", openEmail);
  console.log(resendOtpResponse, "opt err==", otpResponse);
  const currentPhoneNumber =
    (userDataFromSession?.phone
      ? userDataFromSession?.phone
      : signupDetails?.data?.phone) || props?.selectedRowData?.phone;
  // Keep showing the same number (not the "4321" placeholder) when the signup
  // data is cleared after a correct code, until the user moves on.
  const [lastPhoneNumber, setLastPhoneNumber] = useState("");
  useEffect(() => {
    if (currentPhoneNumber) {
      setLastPhoneNumber(currentPhoneNumber);
    }
  }, [currentPhoneNumber]);
  let phn_num = currentPhoneNumber || lastPhoneNumber;
  let emailAdd =
    (userDataFromSession?.phone
      ? userDataFromSession?.email
      : signupDetails?.data?.email) || props?.selectedRowData?.email;

  console.log(phn_num, "email substring==>", censorEmail(emailAdd));
  const phn_num1 = phn_num?.substring(phn_num?.length - 4);
  console.log("isMobileVerified==>", isMobileVerified);
  return (
    <>
      {props?.isTailwindComponent ? (
        <>
          {emailScreen ? (
            <VerifyEmail
              onSubmit={emailOTPValidate}
              handleChangeEmailOTP={handleChangeEmailOTP}
              emailOTP={emailOTP}
              setEmailOTP={setEmailOTP}
              resendOTPButtonClick={resendOTPButtonClick}
              emailOTPErr={emailOTPErr}
              emailOTPSucess={emailOTPSucess}
              emailSpamMsg={emailSpamMsg}
              emailAdd={emailAdd}
              tokenVerified={mobileVerified && emailVerified}
              goNext={goNext}
              userEmail={props?.userEmail}
            />
          ) : (
            <VerifyPhone
              onSubmit={otpValidate}
              handleChange={handleChange}
              SetOTP={SetOTP}
              otp={otp}
              otpErr={otpErr}
              otpSucess={otpSucess}
              phn_num={phn_num}
              resendOTPButtonClick={resendOTPButtonClick}
              userEmail={props?.userEmail}
            />
          )}
        </>
      ) : (
        <Box
          className={`accountBoxWrapper ${
            isBypassOptionAvailable ? "bg-white" : ""
          }`}
        >
          {!emailScreen ? (
            <form onSubmit={otpValidate} id="phone-token-screen-form">
              {/* Hubspot hidden input for cookie breaker */}
              <HubspotCookieBreakerInput userEmail={props?.userEmail} />

              <Typography align="center" variant="h3">
                Enter{" "}
                {role?.includes(ROLES.admin) || role?.includes(ROLES.subAdmin)
                  ? "User's"
                  : "your"}{" "}
                personal token from Mobile number
              </Typography>
              <Typography align="center" variant="body1">
                Please enter the 6 digit security code we have sent to{" "}
                {role?.includes(ROLES.admin) || role?.includes(ROLES.subAdmin)
                  ? "User's"
                  : "your"}{" "}
                mobile phone * *** *** {phn_num1 ? phn_num1 : "4321"}.
              </Typography>
              <Box className="text-center otpBoxWrapper">
                <OtpInput
                  id="otpInput"
                  className="otp mx-1"
                  value={otp}
                  isInputNum
                  onChange={handleChange}
                  numInputs={6}
                  shouldAutoFocus
                  disabled={diableMobileBtn}
                  inputStyle={OTPFieldStyle}
                />
                {otpErr?.length > 0 && otpSucess?.length === 0 ? (
                  <Typography variant="caption" className="text-danger 1" p={2}>
                    {otpErr}
                  </Typography>
                ) : (
                  <Typography
                    variant="caption"
                    className="text-success 3"
                    p={2}
                  >
                    {otpSucess}
                  </Typography>
                )}
              </Box>
              <div className="text-center stepBtn mt-2">
                <Button
                  type="submit"
                  onClick={otpValidate}
                  className="next_button mb-3"
                  variant="contained"
                  disabled={diableMobileBtn}
                >
                  Verify mobile number
                </Button>
              </div>
              <div className="text-center tokenCodeText">
                {isTimerActive ? (
                  <b>Resend OTP in {formatTimeForResendOTP(timer)} seconds</b>
                ) : (
                  <>
                    Did not receive the code?
                    <Button
                      sx={{ textTransform: "none" }}
                      onClick={() => resendOTPButtonClick("phone")}
                    >
                      <Link className="text-blue text-decoration-none" to="">
                        Get a new one
                      </Link>
                    </Button>
                  </>
                )}
              </div>
            </form>
          ) : (
            <form onSubmit={emailOTPValidate} id="email-token-screen-form">
              {/* Hubspot hidden input for cookie breaker */}
              <HubspotCookieBreakerInput userEmail={props?.userEmail} />

              <Typography align="center" variant="h3">
                Enter{" "}
                {role?.includes(ROLES.admin) || role?.includes(ROLES.subAdmin)
                  ? "User's"
                  : "your"}{" "}
                personal token from Email ID
              </Typography>
              <Typography align="center" variant="body1">
                Please enter the 6 digit security code we have sent to{" "}
                {role?.includes(ROLES.admin) || role?.includes(ROLES.subAdmin)
                  ? "User's"
                  : "your"}{" "}
                Email ID &nbsp; {censorEmail(emailAdd)}.
              </Typography>
              <Box className="text-center otpBoxWrapper">
                <OtpInput
                  id="emailOTPInput"
                  className="otp mx-1"
                  value={emailOTP}
                  isInputNum
                  onChange={handleChangeEmailOTP}
                  numInputs={6}
                  shouldAutoFocus
                  inputStyle={OTPFieldStyle}
                  disabled={diableEmailBtn}
                />
                {emailOTPErr?.length > 0 && emailOTPSucess?.length === 0 ? (
                  <Typography variant="caption" className="text-danger 1" p={2}>
                    {emailOTPErr}
                  </Typography>
                ) : (
                  <Typography
                    variant="caption"
                    className="text-success 3"
                    p={2}
                  >
                    {emailOTPSucess}
                  </Typography>
                )}
                {emailSpamMsg?.length > 0 && (
                  <Typography
                    variant="caption"
                    className="text-success 3 fw-500"
                    p={2}
                  >
                    <b>{emailSpamMsg?.length > 0 && emailSpamMsg}</b>
                  </Typography>
                )}
              </Box>
              <div className="text-center stepBtn mt-2">
                <Button
                  type="submit"
                  onClick={emailOTPValidate}
                  className="next_button mb-3"
                  variant="contained"
                  disabled={diableEmailBtn}
                >
                  Verify Email ID
                </Button>
              </div>
              <div className="text-center tokenCodeText">
                {isTimerActive ? (
                  <b>Resend OTP in {formatTimeForResendOTP(timer)} seconds</b>
                ) : (
                  <>
                    Did not receive the code?
                    <Button
                      sx={{ textTransform: "none" }}
                      onClick={() => resendOTPButtonClick("email")}
                    >
                      <Link className="text-blue text-decoration-none" to="">
                        Get a new one
                      </Link>
                    </Button>
                  </>
                )}
              </div>
            </form>
          )}
        </Box>
      )}
      {/* Mobile Loader */}
      <Loader open={open} />
      {/*Email Loader */}
      <Loader open={openEmail} />

      {props.errorPopup && (
        <ContcatAdminSupport
          message={otpErr || emailOTPErr}
          errorPopup={props.errorPopup}
          reduceErrorCount={props.reduceErrorCount}
        />
      )}
    </>
  );
};

export default PersonalTokenScreen;
